enum EmployeesType {
	Teachers = 0,
	Administration = 1
}
export default EmployeesType
